import { PRIVATE_PATHS } from 'utils/paths'

export const ACCEPTED_EXTENSIONS = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'csv', 'txt', 'jpg', 'jpeg', 'png', 'heic', 'webp']
export const ACCEPT_ATTRIBUTE = ACCEPTED_EXTENSIONS.map(ext => `.${ext}`).join(',')
export const MAX_FILE_BYTES = 10 * 1024 * 1024
export const POLL_INTERVAL_MS = 2000
export const MAX_POLLS = 90
export const ACTIVE_STATUSES = ['queued', 'reading', 'drafting']

export const fileProblem = file => {
  if (!file) return 'Choose a file to upload.'
  const ext = String(file.name || '').split('.').pop().toLowerCase()
  if (!ACCEPTED_EXTENSIONS.includes(ext)) {
    return 'That type of file cannot be read. Please choose a PDF, Word, Excel or CSV file, or a photo of your paper checklist.'
  }
  if (file.size > MAX_FILE_BYTES) {
    return 'That file is larger than 10 MB. Please choose a smaller file, or take a photo of the checklist instead.'
  }
  return null
}

export const serverMessage = error => {
  const data = error?.response?.data
  if (data?.message) return data.message
  const firstError = data?.errors && Object.values(data.errors).flat()[0]
  if (firstError) return firstError
  const status = error?.response?.status
  if (status === 403) return 'Only managers of this building can create forms from documents.'
  if (status === 429) return 'You have created a lot of forms in the last hour. Please try again a little later.'
  return 'We could not upload that file. Please check your connection and try again.'
}

export const builderLinkFor = generation => {
  if (!generation?.formTemplateId) return null
  const params = new URLSearchParams({ aiDraft: '1', generationId: String(generation.id) })
  if (generation.targetType && generation.targetId) {
    params.set('targetType', generation.targetType)
    params.set('targetId', String(generation.targetId))
  }
  return `${PRIVATE_PATHS.formBuilderEdit.replace(':id', generation.formTemplateId)}?${params.toString()}`
}

export const questionCountText = count => {
  const n = Number(count) || 0
  return `${n} ${n === 1 ? 'question' : 'questions'}`
}

export const isGenericCompletionForm = template => !!template && template.isObligationCompletion === true
